import React from 'react';
import { string, func, bool } from 'prop-types';
import { includes } from 'lodash';
import { Tooltip } from 'antd';
import { FlexContainer, HasPermissions, Icon, Text, If } from '../../../common';
import { GREEN_DARK } from '../../../../utils/colors';
import { userModuleTypes } from '../../../../utils/misc';

const UserActions = ({ permission, userModuleType, onUserClicked, onClickTrash, isMobile, ...props }) => {
    const iconProps = {
        cursor: 'pointer',
        color: GREEN_DARK,
        size: 21
    };
    return (
        <FlexContainer justify={isMobile ? 'start' : 'space-evenly'}>
            <HasPermissions to={[`${permission}-page:detail`]}>
                <Tooltip placement='left' title={<Text text='Detalle de usuario' color='white' />}>
                    <div>
                        <Icon
                            {...iconProps}
                            name='edit'
                            onClick={onUserClicked}
                            right={16}
                        />
                    </div>
                </Tooltip>
            </HasPermissions>
            <If
                condition={!includes([userModuleTypes[1], userModuleTypes[3]], userModuleType)}
                then={
                    <HasPermissions to={[`${permission}-page:edit`]}>
                        <Tooltip placement='left' title={<Text text='Eliminar usuario' color='white' />}>
                            <div>
                                <Icon
                                    {...iconProps}
                                    name='trash'
                                    onClick={onClickTrash}
                                />
                            </div>
                        </Tooltip>
                    </HasPermissions>
                }
            />
        </FlexContainer>
    );
};

UserActions.propTypes = {
    permission: string,
    userModuleType: string,
    onUserClicked: func,
    onClickTrash: func,
    isMobile: bool
};

UserActions.defaultProps = {
    onUserClicked: () => {},
    onClickTrash: () => {},
    isMobile: false
};

export default UserActions;
